import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { removeAllAccountsAction } from "../../../../data/redux/action/add_customer/addAccountsAction";
import ResizeListener from "../../../../utility/ResizeListener";
import { BeneficiaryHeader } from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/customButton/CustomButton";
import CustomModal from "../../../components/customModal/CustomModal";
import CustomTable from "../../../components/customTable/CustomTable";
import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { Add } from "../../../resources/assetsManager";
import { SUCCESS } from "../../../resources/constantsManager";
import AddBeneficiaryModalIndex from "./add_beneficiary/AddBeneficiaryModalIndex";
import SendMoneyToBeneIndex from "./add_beneficiary/individual/SendMoneyToBeneIndex";

function BeneficiaryIndex() {
  const { width, height } = ResizeListener();
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [viewMoreData, setViewMoreData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [offset, setOffset] = useState(0);
  const [onClickAddCustomer, setOnClickAddCustomer] = useState(false);
  const [onClickSendMoney, setOnClickSendMoney] = useState(false);
  const [isTableDataError, setIsTableDataError] = useState(false);

  const getAllBeneficiaryList = (page, size, keyWord = "") => {
    ApiRequestPost.getAllBeneficiary(page, size, keyWord)
      .then((res) => {
        if (res.status === SUCCESS) {
          setData(res.data.content);
          setTotalElements(res.data.totalElements);
          setTotalPages(res.data.totalPages);
          setIsTableDataError(false);
        } else {
          setTotalElements(0);
          setTotalPages(0);
          setIsTableDataError(true);
        }
      })
      .catch((err) => {
        setIsTableDataError(true);
      });
  };
  const navigate = useNavigate();
  useEffect(() => {
    getAllBeneficiaryList(0, 10);
  }, []);
  return (
    <>
      <TopHeaderComponent
        headerName="Beneficiary Management"
        isSearchRequired={true}
        inputStyle={{
          width: width * 0.3,
          minWidth: 300,
        }}
        textStyle={{
          fontWeight: "500",
        }}
        placeholder="Search Beneficiary Name, Acc No"
        onClickBack={() => {
          navigate(-1);
        }}
        onSearchStart={(val) => {
          setOffset(0);
          getAllBeneficiaryList(0, 10, val);
        }}
        showFilter={false}
        showDownload={false}
        showDeveloper={
          <CustomButton
            title="Add Beneficiary"
            styles={{
              border: "none",
              width: "100%",
              borderRadius: 6,
              minWidth: 150,
            }}
            icon={Add}
            onClick={() => {
              setOnClickAddCustomer(true);
            }}
          />
        }
        validator="comment"
      />
      <div
        style={{
          marginTop: "20px",
        }}
      >
        <CustomTable
          headers={BeneficiaryHeader}
          totalElements={totalElements}
          data={data}
          totalPages={totalPages}
          handlePaginate={(page) => {
            setOffset(page);
            getAllBeneficiaryList(page, 10);
          }}
          offset={offset}
          isFilterApplied={isFilterApplied}
          onClickViewBeneficiary={(data) => {
            console.log(data);
            setViewMoreData(data);
            setOnClickSendMoney(true);
          }}
          onClickBeneAccNo={(val) => {
            navigate(`/beneficary/${val?.beneficiaryName}`, {
              state: val,
            });
            // beneficiaryDetails
          }}
          isTableDataError={isTableDataError}
        />
      </div>

      {onClickAddCustomer && (
        <CustomModal
          open={onClickAddCustomer}
          onClose={() => {
            setOnClickAddCustomer(false);
          }}
        >
          <AddBeneficiaryModalIndex
            onClose={() => {
              setOnClickAddCustomer(false);
            }}
            onSuccess={() => {
              getAllBeneficiaryList(0, 10);
            }}
          />
        </CustomModal>
      )}
      {onClickSendMoney && (
        <CustomModal
          open={onClickSendMoney}
          onClose={() => {
            setOnClickSendMoney(false);
          }}
        >
          <SendMoneyToBeneIndex
            onClose={() => {
              setOnClickSendMoney(false);
            }}
            beneficiaryDetails={viewMoreData}
            onSuccess={() => {
              setOnClickSendMoney(false);
              getAllBeneficiaryList(0, 10);
            }}
          />
        </CustomModal>
      )}
    </>
  );
}

export default BeneficiaryIndex;
